import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-password-generation',
  templateUrl: './password-generation.component.html',
  styleUrls: ['./password-generation.component.less']
})
export class PasswordGenerationComponent implements OnInit {
  @Input()
  passwordFormGroup!: FormGroup;
  @Input()
  passwordPolicyArr!: any[];
  @Input() isOldPasswordRequired: boolean = false;
  @Input() isFromUserCreation: boolean = false;
  hideOldPassword: boolean = true;
  hideNewPassword: boolean = true;
  hideConfirmPassword: boolean = true;
  passwordCheckMsg: any;
  newPasswordCheckMsg: any;

  constructor(public translate: TranslateService) {
    this.translate.addLangs(['en']);
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  ngOnInit(): void {
    this.passwordCheckMsg = this.translate.instant("ERROR.NEWPWD.NEWPASSD_OLDPASSD_CHECK");
    this.newPasswordCheckMsg = this.translate.instant("ERROR.CONFIRMPWD.MUSTMATCH");
  }

  get username() {
    return this.passwordFormGroup.get('newPwd');
  }
}
